import React from 'react';
import { useSelector } from 'react-redux';
import StatusPage from '../../components/StatusPage/StatusPage';
import { enrollmentErrorSelector } from '../ReportsSelector';

const Error = () => {
  const enrollmentError = useSelector(enrollmentErrorSelector);

  return (
    <StatusPage icon="fas fa-exclamation-circle" iconColor="#dd6c64" accentColor="#fde1e6">
      {enrollmentError}
    </StatusPage>
  );
};

export default Error;
